import { render } from "./ModalAddTag.vue?vue&type=template&id=06a8280a&scoped=true"
import script from "./ModalAddTag.vue?vue&type=script&lang=js"
export * from "./ModalAddTag.vue?vue&type=script&lang=js"

import "./ModalAddTag.vue?vue&type=style&index=0&id=06a8280a&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a8280a"]])

export default __exports__